export class RegexPatternConstants {
    public static EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
    public static PASSWORD_REGEX = /[!@#$\-%^&*(),.?"\~\`\'\+\=\_:\;\[\]\\\/{}|<>]/
    public static URL_REGEX = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
}
